const documentPropertyItems = [];

const deleteProperty = key => {
    const item = documentPropertyItems.find(p => p.key === key);
    if (item) {
        documentPropertyItems.splice(documentPropertyItems.indexOf(item), 1);
    }
}

const mockDocumentProperties = {
    customProperties: {
        load: (props) => console.log(`Loaded the following properties for customProperties: ${props}.`),
        add: (key, value) => documentPropertyItems.push({ key, value, delete: () => deleteProperty(key) }),
        items: documentPropertyItems
    }
}

const mockParagraph = {
    insertHtml: (html, position) => {
        console.log(`Inserted the following HTML into the paragraph with position '${position}':\n\n${html}`);
    },
    select: (position) => {
        console.log(`Moved the selection to the '${position}' position in the paragraph.`);
    }
}

const mockContentControl = {
    title: "",
    placeholderText: "",
}

const mockSelection = {
    inlinePictures: {
        items: [],
        load: props => console.log(`Loaded the following properties for inlinePictures: ${props}.`)
    },
    context: {
        sync: () => new Promise(resolve => {
            console.log("Context synchronised.");
            resolve();
        })
    },
    isEmpty: false,
    parentContentControl: null,
    parentContentControlOrNullObject: { isNull: true },
    load: properties => console.log(`Loaded the following propertie(s) for the selection: ${properties}`),
    clear: () => console.log("Cleared selection."),
    insertParagraph: (text, position) => {
        console.log(`Inserted new paragraph with text '${text}' with position '${position}'.`);
        return mockParagraph;
    },
    insertContentControl: () => {
        console.log("Inserted new content control.");
        return mockContentControl;
    },
    insertOoxml: (ooxml, position) => {
        console.log(`Inserted the following XML with position '${position}':`);
        console.log(ooxml);
        return this;
    },
    getHtml: () => ({ value: "<h1>Lorum Ipsum</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vestibulum porta dui a accumsan. Aenean porta blandit metus, id iaculis leo. Nulla varius nibh nec ultrices faucibus. Curabitur et arcu et nunc vestibulum dapibus ac id erat. Nulla tempor sem at ligula dictum, non lobortis ipsum consectetur.</p>" })
}

const mockContext = {
    document: {
        properties: mockDocumentProperties,
        getSelection: () => {
            console.log("Acquired selection.");
            return mockSelection;
        }
    },
    sync: () => new Promise(resolve => {
        console.log("Context synchronised.");
        resolve()
    })
}

class WordMock {
    run(func) {
        func(mockContext);
    }
}

export default WordMock;